<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to"
    :style="height ? `height:${height}` : ''"
  >
    <div
      class="card is-relative clickable"
      :style="height ? `height:${height}` : ''"
    >
      <div class="card-image" v-if="hasImage">
        <figure class="image is-clipped" :class="{ [ratio]: true }">
          <slot name="image"></slot>
        </figure>
      </div>
      <div class="bottom-fixed-card-content card-content" v-if="hasMedia">
        <div class="media">
          <div class="media-content">
            <slot name="title"></slot>
            <v-clamp
              v-if="!$slots.title"
              autoresize
              :title="title"
              :max-lines="1"
              class="is-size-5-touch is-size-4 is-bold"
              >{{ title }}</v-clamp
            >
            <slot name="subtitle"></slot>
            <v-clamp
              v-if="!$slots.subtitle"
              autoresize
              :max-lines="1"
              :title="subtitle"
              class="subtitle is-size-6-touch is-size-5"
            >
              {{ subtitle }}
            </v-clamp>
          </div>
        </div>
      </div>
      <div class="content" v-if="hasContent">
        <slot name="content"></slot>
      </div>
    </div>
  </component>
</template>
<script>
import VClamp from "vue-clamp";

export default {
  components: {
    VClamp
  },
  props: {
    ratio: {
      type: String,
      default: "is-3by2"
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    hasContent: {
      type: Boolean,
      default: false
    },
    hasMedia: {
      type: Boolean,
      default: true
    },
    hasImage: {
      type: Boolean,
      default: true
    },
    height: {
      type: String
    },
    to: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";

.clickable {
  cursor: pointer;
}
.bottom-fixed-card-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 1rem;
  color: $text;
}
</style>
